import { spacer40, spacer16, cssColorValue, } from '@spotify-internal/encore-web/core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { NavBarHeightSmScreen } from '../../../constants';
import { ONE_COLUMN_MAX_WIDTH } from '../../../FlyoutMenu/MenuLayouts/Grid';
import { SECONDS_OUT } from '../FlyoutMenu/config';
import { MenuHeader } from './MenuHeader';
import { MenuTrigger } from './MenuTrigger';
const HeaderWrapper = styled.header.withConfig({
    shouldForwardProp: prop => !['isScrollingUp', 'isSideNavOpen'].includes(prop),
}) `
  transform: ${props => !props.theme.isScrolling || props.isScrollingUp || props.isSideNavOpen
    ? 'none'
    : `translateY(-${NavBarHeightSmScreen}px)`};

  color: ${cssColorValue('textBase')};
  background-color: ${props => {
    if (!props.theme.isScrolling) {
        return 'transparent';
    }
    return 'black';
}};
  height: ${NavBarHeightSmScreen}px;
  align-items: center;
  box-sizing: border-box;
  transition: transform 400ms ease,
    background
      ${props => props.theme.isScrolling
    ? '1000ms cubic-bezier(0.9, 0, 1, 1)'
    : '400ms ease'};

  display: flex;
  flex: 1;
  justify-content: space-between;
  position: fixed;
  padding-inline: ${spacer40};
  top: 0;
  width: 100%;
  z-index: 1000;
  overflow: hidden;
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    padding-inline: ${spacer16};
  }
`;
export const TopBar = ({ isMenuOpen, openMenu, closeMenu, isScrollingUp, onBack, label, }) => {
    const [isMenuClosing, setIsMenuClosing] = useState(false);
    useEffect(() => {
        setTimeout(() => setIsMenuClosing(false), (SECONDS_OUT + 0.1) * 1000);
    }, [isMenuClosing]);
    return (React.createElement(HeaderWrapper, { isScrollingUp: isScrollingUp, isSideNavOpen: isMenuOpen, className: "encore-creator-light-theme encore-inverted-dark-set" },
        React.createElement(MenuHeader, { isMenuOpen: isMenuOpen, onBack: onBack, label: label }),
        React.createElement(MenuTrigger, { isMenuOpen: isMenuOpen, onOpen: () => !isMenuClosing && openMenu(), onClose: () => {
                setIsMenuClosing(true);
                closeMenu();
            } })));
};
//# sourceMappingURL=index.js.map